<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-dialog
        v-model="dialogCreate"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogCreate"
      >
        <v-card class="no__padding">
          <v-card-title class="pl-0 pt-0">
            <h2>Vytvořit nový produkt</h2>
          </v-card-title>
          <v-card-text class="pa-0" :class="{'pt-0 pb-2':$vuetify.breakpoint.smAndUp}">
            <v-form ref="createForm" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field label="Název" v-model="newItem.nazev" class="mx-2" :rules="rulesRequired"></v-text-field>
                </v-flex>
                <v-radio-group v-model="newItem.typ_produktu" row>
                  <v-radio label="Slitek" value="slitek"></v-radio>
                  <v-radio label="Mince" value="mince"></v-radio>
                  <v-radio label="Statický produkt" value="staticky"></v-radio>
                </v-radio-group>
                <v-checkbox label="Produkt se sériovým číslem" v-model="newItem.vyzadovat_seriove_cislo"></v-checkbox>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-3 elevation-0" dark @click="create" :loading="sending">Vytvořit</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogCreate=false" v-if="!sending">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap>
              <v-flex xs12>
                <h3>Běžné produkty</h3>
              </v-flex>
            </v-layout>
            <v-layout row wrap align-center class="mt-3">
              <v-flex xs12 sm4 md4 lg3>
                <v-text-field
                  label="Hledat dle názvu produktu"
                  class="mx-2"
                  v-model="search"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 md4 lg2>
                <material v-model="material" all></material>
              </v-flex>
              <v-flex xs12 sm5 md4 lg3>
                <kategorie v-model="kategorie" all></kategorie>
              </v-flex>
              <v-flex xs12 sm4 md4 lg2>

              </v-flex>
              <v-flex xs12 sm8 md8 lg2 class="text-xs-center text-sm-right">
                <v-btn color="blue darken-3" class="ma-0 mb-3" :class="{'v-btn--block': $vuetify.breakpoint.xs}" outline @click="createClick">
                  <v-icon class="mr-2">add</v-icon>
                  Vytvořit produkt
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap align-center class="mx-2">
              <v-flex xs12 sm3 lg4>
                <v-btn-toggle mandatory v-model="filtr_stav" class="btn-toggle__mobile mb-3">
                  <v-btn value="vse">Vše</v-btn>
                  <v-btn value="aktivni">Aktivní</v-btn>
                  <v-btn value="neaktivni">Neaktivní</v-btn>
                </v-btn-toggle>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                :loading="loadingTable"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
              >
                <template slot="items" slot-scope="props">
                  <td style="min-width: 0; max-width: 24px;"><v-checkbox disabled v-model="props.item.aktivni" hide-details style="max-width: 40px;"></v-checkbox></td>
                  <td>
                    <router-link :to="{ path: '/produkty/'+props.item.id }">{{ props.item.nazev }}</router-link>
                    <v-chip color="deep-orange" v-if="props.item.top_produkt" small dark style="pointer-events: none;" class="mx-2">TOP produkt</v-chip>
                    <v-chip color="blue" v-if="props.item.pevna_cena" small dark style="pointer-events: none;" class="mx-2">Pevná cena</v-chip>
                  </td>
                  <td><span v-if="props.item.kategorie!=null">{{ props.item.kategorie.nazev }}</span></td>
                  <td style="min-width: 300px;">
                    <v-layout row wrap>
                      <v-flex v-for="(cena, n) in props.item.aktualni_ceny" class="text-xs-right" xs4 :key="'produkt-' + props.item.id.toString() + '-prodejni-cena-' + n.toString()">
                        {{cena.prodejni_cena | formatMoney}} {{cena.mena.zkratka}}
                      </v-flex>
                    </v-layout>
                  </td>
                  <td class="text-xs-right">
                    <span v-for="(cena, n) in props.item.aktualni_ceny" :key="'produkt-' + props.item.id.toString() + '-vykupni-cena-' + n.toString()"><span v-if="cena.vykupni_cena != null && cena.vykupni_cena > 0"><span v-if="n > 0"> / </span>{{cena.vykupni_cena | formatMoney}} {{cena.mena.zkratka}}</span></span>
                  </td>
                  <!--<td>{{ props.item.kredity_jednorazovy_nakup }}</td>-->
                  <td class="text-xs-center">
                    <router-link :to="{ path: '/produkty/'+props.item.id }" target="_blank">
                      <v-btn color="primary" class="elevation-0">
                        <v-icon small class="mr-2">remove_red_eye</v-icon>
                        Detail
                      </v-btn>
                    </router-link>
                    <router-link :to="{ path: '/produkty/'+props.item.id+'/upravit' }" target="_blank">
                      <v-btn color="primary" class="elevation-0" flat>
                        <v-icon small class="mr-2">edit</v-icon>
                        Upravit
                      </v-btn>
                    </router-link>
                    <!--<v-btn flat icon color="red" class="elevation-0">
                      <v-icon>delete</v-icon>
                    </v-btn>-->
                    <!-- TODO Dodělat smazání produktu se zachováním v historii -->
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      updateItem: {},
      headers: [
        { text: 'Aktivní', value: 'aktivni', width: '30px' },
        { text: 'Název', value: 'nazev' },
        { text: 'Kategorie', value: 'kategorie' },
        { text: 'Aktuální prodejní cena', value: 'aktualni_prodejni_cena', align: 'left' },
        { text: 'Aktuální výkupní cena', value: 'aktualni_vykupni_cena', align: 'right' },
        //{ text: 'Kredit (jednorázový nákup)', value: 'kredity_jednorazovy_nakup' },
        { text: 'Akce', value: null, sortable: false, align: 'center' }
      ],
      loadingTable: true,
      search: "",
      material: null,
      kategorie: null,
      timeout: null,
      counter: 0,
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 25,
        sortBy: "nazev",
        totalItems: 0
      },
      items: [],
      valid: true,
      dialogCreate: false,
      sending: false,
      dialogInit: { nazev: null, typ_produktu: "slitek", vyzadovat_seriove_cislo: false },
      newItem: null,
      // Dialog create end
      // Rules start
      rulesRequired: [
        (v) => !!v || "Pole je vyžadováno"
      ],
      pouze_aktivni: false,
      filtr_stav: "vse"
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
  },
  watch: {
    search () {
      this.queryList();
    },
    material () {
      this.pagination.page = 1;
      this.load();
    },
    kategorie () {
      this.pagination.page = 1;
      this.load();
    },
  	pagination: {
  		handler: function(newValue) {
        if (!this.loadingTable)
  			   this.load();
  		},
  		deep: true
  	},
    pouze_aktivni () {
      this.pagination.page = 1;
      this.load();
    },
    filtr_stav () {
      this.pagination.page = 1;
      this.load();
    }
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function() {
      this.counter++;
      this.loadingTable = true;
      window.API.post("produkty/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter,
        material: this.material,
        kategorie: this.kategorie,
        pouze_aktivni: this.pouze_aktivni,
        stav: this.filtr_stav
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    createClick () {
      this.newItem = window.th.copy(this.dialogInit);
      this.dialogCreate = true;
    },
    create () {
      if (this.$refs.createForm.validate()) {
        this.sending = true;
        this.newItem.kategorie_id = 1;
        this.newItem.mena_id = 1;
        window.API.post("produkty", this.newItem).then(function(body) {
          if (body.inserted) {
            this.$router.push({path:"/produkty/"+body.data.id+'/upravit'});
          }
          this.sending = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
          this.sending = false;
        }.bind(this));
      }
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Produkty/Produkty.vue